import React from 'react';

import IconServicesFive from './assets/icon-services-five.svg';
import IconServicesFour from './assets/icon-services-four.svg';
import IconServicesOne from './assets/icon-services-one.svg';
import IconServicesSix from './assets/icon-services-six.svg';
import IconServicesThree from './assets/icon-services-three.svg';
import IconServicesTwo from './assets/icon-services-two.svg';

export default [
  {
    id: 'icondecoration1',
    icon: <IconServicesOne />,
  },
  {
    id: 'icondecoration2',
    icon: <IconServicesTwo />,
  },
  {
    id: 'icondecoration3',
    icon: <IconServicesThree />,
  },
  {
    id: 'icondecoration4',
    icon: <IconServicesFour />,
  },
  {
    id: 'icondecoration5',

    icon: <IconServicesFive />,
  },
  {
    id: 'icondecoration6',
    icon: <IconServicesSix />,
  },
];
